import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d51da37e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "tagCmp" }
const _hoisted_2 = {
  key: 0,
  style: {"display":"block","width":"14px","height":"auto"},
  fill: "none",
  viewBox: "0 0 14 11"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "#FCFDFF",
  "fill-rule": "evenodd",
  d: "M13.7.7c.3.2.4.7.1 1l-7.5 9a.8.8 0 0 1-1.1 0L.7 5.5a.7.7 0 1 1 1.1-1l4 4.6L12.6.8c.2-.3.7-.4 1-.1Z",
  "clip-rule": "evenodd"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "info-labels" }
const _hoisted_6 = { class: "info-labels" }
const _hoisted_7 = { class: "info-labels" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_tags_input = _resolveComponent("vue-tags-input")!
  const _component_app_small_loader = _resolveComponent("app-small-loader")!
  const _component_app_label = _resolveComponent("app-label")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["vue-tag-wrapper", { 'with-done': _ctx.showDoneControl }])
    }, [
      _createVNode(_component_vue_tags_input, {
        ref: "inputElement",
        id: "inpEl",
        modelValue: _ctx.tag,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tag) = $event)),
        tags: _ctx.skeleton ? [] : _ctx.isAppMediaView ? _ctx.mainStore.inputPhotoViewTags : _ctx.isPhoto ? _ctx.mainStore.inputPhotoTags : _ctx.isFile ? _ctx.mainStore.inputFileTags : _ctx.mainStore.inputCaseTags,
        "add-on-blur": false,
        "add-from-paste": false,
        onTagsChanged: _ctx.updateTags,
        onFocus: _ctx.onFocus,
        onBlur: _ctx.onBlur,
        onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchInputLabels($event))),
        onBeforeAddingTag: _ctx.saveTag,
        onBeforeDeletingTag: _ctx.deleteTag,
        placeholder: _ctx.$localize('label.placeholder'),
        disabled: _ctx.skeleton
      }, null, 8, ["modelValue", "tags", "onTagsChanged", "onFocus", "onBlur", "onBeforeAddingTag", "onBeforeDeletingTag", "placeholder", "disabled"]),
      (_ctx.showDoneControl)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inputDone && _ctx.inputDone(...args))),
            class: _normalizeClass(["done-control", { 'done-control--disabled': _ctx.toBeDisabled }])
          }, [
            (!_ctx.isLabelSaving)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
              : (_openBlock(), _createBlock(_component_app_small_loader, {
                  key: 1,
                  size: 14
                }))
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.showInfoBox && _ctx.recentLabelsList.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "info-block",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPreventBlur && _ctx.onPreventBlur(...args)))
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$localize('label.recent')), 1),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentLabelsList, (recent) => {
              return (_openBlock(), _createBlock(_component_app_label, {
                key: recent.id,
                onClick: ($event: any) => (_ctx.addTag(recent))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(recent.name), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showInfoBox && _ctx.mainStore.getSuggestedInputLabels(_ctx.isFile, _ctx.isPhoto).length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "info-block",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onPreventBlur && _ctx.onPreventBlur(...args)))
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$localize('label.suggestions')), 1),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStore.getSuggestedInputLabels(_ctx.isFile, _ctx.isPhoto), (suggested) => {
              return (_openBlock(), _createBlock(_component_app_label, {
                key: suggested.id,
                onClick: ($event: any) => (_ctx.addTag(suggested))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(suggested.name), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.tag)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "info-block",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onPreventBlur && _ctx.onPreventBlur(...args)))
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$localize('label.suggestions')), 1),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStore.getSearchInputLabels(_ctx.isFile, _ctx.isPhoto), (search) => {
              return (_openBlock(), _createBlock(_component_app_label, {
                key: search.id,
                onClick: ($event: any) => (_ctx.addTag(search))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(search.name.slice(0, _ctx.tag.length)), 1),
                  _createTextVNode(_toDisplayString(search.name.slice(_ctx.tag.length, search.name.length)), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}